import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';

/** Syncs document class for CSS var --fhxd-chrome-height (nav + optional admin banner). */
export function useSiteChrome() {
  const { user } = useAuth();
  const isAdminView = Boolean(user?.isAdminSession);

  useEffect(() => {
    document.documentElement.classList.toggle('fhxd-admin-view', isAdminView);
    return () => {
      document.documentElement.classList.remove('fhxd-admin-view');
    };
  }, [isAdminView]);

  return { isAdminView };
}
